// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { IconCloseTablet } from 'components/atoms/icons/IconCloseTablet';
import { Modal } from 'components/atoms/Modal';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalType } from 'util/Enums';
import styles from './CreateUpdateSiteGroupModal.module.scss';
import { CommonSite } from 'util/Types';
import CreateUpdateSiteGroupForm, {
  SiteGroupInput,
} from 'components/molecules/CreateUpdateSiteGroupForm';

export type SiteGroup = {
  id: number;
  name: string;
  sites: CommonSite[];
};

export interface SiteGroupCreateEditModalType {
  type: ModalType;
  group?: SiteGroup;
}

interface Props {
  onClose: () => void;
  groupData: SiteGroupCreateEditModalType;
  onSubmit: (form: SiteGroupInput, groupId?: number) => void;
}

const CreateUpdateSiteGroupModal: React.FC<Props> = ({
  onClose,
  groupData,
  onSubmit,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.siteGroupModal}>
      <Modal>
        <div className={styles.modalContent}>
          <div className={styles.customTitle}>
            <p className={styles.descriptionTitle}>
              {groupData.type === ModalType.add
                ? t('site_group_management.modal_add.title')
                : t('site_group_management.modal_edit.title')}
            </p>
            <div className={styles.top} onClick={onClose}>
              <IconCloseTablet />
            </div>
          </div>
          <CreateUpdateSiteGroupForm
            groupData={groupData}
            onSubmit={onSubmit}
          />
        </div>
      </Modal>
    </div>
  );
};

export default CreateUpdateSiteGroupModal;
